import { create } from 'zustand';
import { ATLAS_SCENE_NAME } from '../app/home/utils';

interface UnityDataState {
  unityData: any;

  updateTokens: (tokens: any) => void;
  updateNeedsPasswordToLogout: (needsPasswordToLogout: boolean) => void;
  updatePlatformUrl: (platformUrl: string) => void;
  updateSolverUrl: (platformUrl: string) => void;
  overwriteState: (newState: any) => void;
  updateBridgeIsReady: (isReady: boolean) => void;
  resetToAtlasBuild: () => void;
  resetUnityData: () => void;
  isInitialized: () => boolean;
  updateQuizNextActivity: (quizNextActivity: boolean) => void;
}

export const useUnityDataStore = create<UnityDataState>((set, get) => ({
  unityData: {
    Tokens: {
      AccessToken: undefined,
      RefreshToken: undefined,
      IdToken: undefined,
      ClientID: undefined,
    },
    bridgeIsReady: false,
    PlatformUrl: undefined,
    SolverUrl: undefined,
    sceneName: ATLAS_SCENE_NAME,
    SceneName: ATLAS_SCENE_NAME,
    quizNextActivity: false,
    needsPasswordToLogout: false,
  },

  updateTokens: (tokens) =>
    set((state) => ({
      unityData: {
        ...state.unityData, // keep other fields
        Tokens: {
          ...state.unityData.Tokens, // keep old tokens
          ...tokens, // merge new tokens
        },
      },
    })),

  updateNeedsPasswordToLogout: (needsPasswordToLogout) =>
    set((state) => ({
      unityData: {
        ...state.unityData,
        needsPasswordToLogout: needsPasswordToLogout,
      },
    })),

  updatePlatformUrl: (platformUrl) =>
    set((state) => ({
      unityData: {
        ...state.unityData,
        PlatformUrl: platformUrl,
      },
    })),

  updateSolverUrl: (solverUrl) =>
    set((state) => ({
      unityData: {
        ...state.unityData,
        SolverUrl: solverUrl,
      },
    })),

  updateBridgeIsReady: (isReady) =>
    set((state) => ({
      unityData: {
        ...state.unityData,
        bridgeIsReady: isReady,
      },
    })),

  overwriteState: (newState) =>
    set((state) => ({
      unityData: {
        ...state.unityData, // keep existing keys
        ...newState, // overwrite & add unknown keys
        bridgeIsReady: false,
      },
    })),

  resetToAtlasBuild: () =>
    set((state) => ({
      unityData: {
        ...state.unityData,
        sceneName: ATLAS_SCENE_NAME,
        SceneName: ATLAS_SCENE_NAME,
        bridgeIsReady: false,
        quizNextActivity: false,
      },
    })),

  resetUnityData: () =>
    set(() => ({
      unityData: {
        Tokens: {
          AccessToken: undefined,
          RefreshToken: undefined,
          IdToken: undefined,
          ClientID: undefined,
        },
        bridgeIsReady: false,
        PlatformUrl: undefined,
        SolverUrl: undefined,
        sceneName: ATLAS_SCENE_NAME,
        SceneName: ATLAS_SCENE_NAME,
        quizNextActivity: false,
      },
    })),

  isInitialized: () => {
    const { Tokens, PlatformUrl, SolverUrl } = get().unityData;

    const tokensValid =
      Tokens.AccessToken !== undefined &&
      Tokens.RefreshToken !== undefined &&
      Tokens.IdToken !== undefined &&
      Tokens.ClientID !== undefined;

    const urlsValid = PlatformUrl !== undefined && SolverUrl !== undefined;

    return tokensValid && urlsValid;
  },

  updateQuizNextActivity: (quizNextActivity) =>
    set((state) => ({
      unityData: {
        ...state.unityData,
        quizNextActivity: quizNextActivity,
      },
    })),
}));
